module.exports = __webpack_public_path__ + "img/12.078d4860.jpeg";